module.exports = __webpack_public_path__ + "static/media/hot_zgyyggp.c18917f8.png";